import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import Header from "../header";
import axios from "axios";
import { apiCall_domain } from "../api";
import { makeStyles } from "@mui/styles";
import Spinner from "../Spinner/Spinner";
import { Link, withRouter } from "routerCompat";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;

class OrderDetails extends Component {
  //States
  state = {
    locationId: this.props.match.params.id,
    myOrderDetails: null,
    loading: true,
    address_phone: null,
    depot_phone: null,
    text: "",
    postAmount: null,
  };
  getFactorUrl = () => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/orders/getFactorUrl`,
        { order_id: this.state.locationId },
        {
          headers: headers,
        },
      )
      .then((res) => {
        window.open(res.data.data);
      });
  };
  componentDidMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };

    axios
      .get(
        `${apiCall_domain}/customer/user/orders/${this.props.match.params.id}`,
        {
          headers: headers,
        },
      )
      .then((res) => {
        this.setState({
          loading: false,
          myOrderDetails: res.data.data,
          address_phone: res.data.data.address_phone,
          depot_phone: res.data.data.depot_phone,
          text: res.data.data.text,
          postAmount: res.data.data.delivery_cost,
        });
      });
  }
  pushTicket = () => {
    this.props.history.push({
      pathname: "/ticket",
    });
  };
  openMap = () => {
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf("iPhone") != -1 ||
      navigator.platform.indexOf("iPad") != -1 ||
      navigator.platform.indexOf("iPod") != -1
    )
      window.open(`maps://maps.google.com/maps?daddr=<lat>,<long>&amp;ll=`);
    /* else use Google */ else
      window.open(
        `https://maps.google.com/maps?daddr=${
          this.state.myOrderDetails?.lat || "0.0"
        },${this.state.myOrderDetails?.lng || "0.0"}&amp;ll=`,
      );
  };
  render() {
    return (
      <>
        <Header
          showSearchBar={true}
          title={`سفارش ${this.props.match.params.id}#`}
          backUrl="/profile/myOrders"
        />
        {this.state.loading ? (
          <Spinner />
        ) : (
          <div className="orderDetailMain">
            <div className="allCards">
              <div className="orderDetailsCard">
                <div className="orderDetailsCardHeadRows">
                  <div className="divImgs">
                    <img
                      src="/public/assets/icons/sefaresh.svg"
                      alt="جزییات سفارش"
                    />
                  </div>
                  <p className="headerP">جزییات سفارش</p>
                </div>
                <div className="orderDetailsCardRowsBody">
                  <div className="orderDetailsCardRows">
                    <span className="maGraySpan">وضعیت :</span>
                    <span className="maBlackSpan">
                      &nbsp;{this.state.myOrderDetails.status_text}
                    </span>
                  </div>
                  <div className="orderDetailsCardRows">
                    <span className="maGraySpan">زمان :&nbsp;</span>
                    <span className="maBlackSpan">
                      {this.state.myOrderDetails.time === null
                        ? ""
                        : `${this.state.myOrderDetails.time.start_ts} - ${this.state.myOrderDetails.time.stop_ts} `}
                    </span>
                  </div>
                  {this.state.myOrderDetails.legal_info ? (
                    <div className="orderDetailsCardRows">
                      <span className="maGraySpan">نام سازمان :&nbsp;</span>
                      <span className="maBlackSpan">
                        {" "}
                        {this.state.myOrderDetails.legal_info.organization_name}
                      </span>
                    </div>
                  ) : null}

                  <div className="orderDetailsCardRows">
                    <span className="maGraySpan">سفارشات</span>
                  </div>
                  {this.state.myOrderDetails.items.map((item, i) => (
                    <div className="orderDetails" key={i}>
                      <div className="orderDetailsHeader">
                        <div className="first">
                          <span>
                            {item.name}{" "}
                            {item.variant_title
                              ? ` - ${item.variant_title}`
                              : ""}
                          </span>
                        </div>
                        <div className="seccond">
                          <div className="seccondRight">
                            <span>تامین کننده : </span>
                            <span>{item.vendor_name}</span>
                          </div>
                        </div>
                      </div>
                      <div className="orderDetailsMiddle">
                        <div className="rightDiv">
                          <p>تعداد : {item.qnt}</p>
                          <p>قیمت : {item.price}</p>
                        </div>
                        <div className="leftDiv">
                          <p>نصب : {item.install_need === 1 ? "بله" : "خیر"}</p>
                          <p>اتمام گارانتی : {item.guaranty_expire}</p>
                        </div>
                      </div>
                      <div className="orderDetailsFooter">
                        <span>راهنمای نگهداری</span>
                        <span>راهنمای گارانتی</span>
                      </div>
                      <div className="orderDetailsFooter">
                        <div>
                          <div className="orderDetailsDet">
                            <span>هزینه نصب:</span>
                            <span>{item?.install_price} تومان</span>
                          </div>
                          <div className="orderDetailsDet">
                            <span>وضعیت :</span>
                            <span>{item.status_text} </span>
                          </div>
                        </div>
                        <div>
                          <Link
                            to={`/addComment/${item.item_vendor_id}/${item.vendor_id}`}
                          >
                            <div className="submitComment">ثبت دیدگاه</div>
                          </Link>
                          {item.cancel_time ? null : (
                            <Link
                              to={`${this.props.match.params.id}/submitProblem/${item.item_vendor_id}/${item.vendor_id}`}
                            >
                              <div className="submitProblem submitComment">
                                {" "}
                                ثبت مشکل
                              </div>
                            </Link>
                          )}
                        </div>
                        {item.day && (
                          <div className="orderDetailsDet">
                            <span>زمان تحویل</span>
                            <span>
                              {item.time.start_ts}- {item.time.stop_ts}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="orderDetailsCard">
                <div className="orderDetailsCardHeadRows">
                  <img src="/public/assets/icons/location.svg" alt="مکان" />
                  <p className="headerP">محل تحویل سفارشات</p>
                </div>
                <div className="orderDetailsCardRowsBody">
                  <div className="orderDetailsCardRows">
                    {this.state.myOrderDetails.address}
                  </div>
                  <div className="orderDetailsCardRows deff">
                    <div className="listSpan">
                      <span className="maGraySpan">شماره تماس :&nbsp;</span>
                      <span className="maBlackSpan">
                        {this.state.address_phone !== null
                          ? this.state.address_phone
                          : this.state.depot_phone !== null
                            ? this.state.depot_phone
                            : "ندارد"}
                      </span>
                    </div>
                    {this.state.myOrderDetails?.lat &&
                      this.state.myOrderDetails?.lng && (
                        <div className="radiosImg" onClick={this.openMap}>
                          <img
                            src="/public/assets/icons/location.svg"
                            alt="مکان"
                          />
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="orderDetailsCard">
                <div className="orderDetailsCardHeadRows">
                  <div className="divImgs">
                    <img
                      src="/public/assets/icons/finalUser.svg"
                      alt="توضیحات"
                    />
                  </div>
                  <p className="headerP">توضیحات کاربر</p>
                </div>
                <div className="orderDetailsCardRowsBody">
                  <div className="orderDetailsCardRows">
                    {this.state.text !== "" ? (
                      this.state.text
                    ) : (
                      <p className="maGraySpan">توضیحات نوشته نشده است.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="orderDetailsCard">
                <div className="orderDetailsCardHeadRows">
                  <div className="divImgs">
                    <img src="/public/assets/icons/details.svg" alt="گزارش" />
                  </div>
                  <p className="headerP">گزارش مالی</p>
                </div>
                <div className="orderDetailsCardRowsBody">
                  <div className="creditDetails">
                    <span className="maGraySpan">جمع کل سفارشات</span>
                    <div className="creditDetailsSpans">
                      <span className="maBlackSpan">
                        {this.state.myOrderDetails.price}
                      </span>
                      &nbsp;
                      <span className="maBlackSpan">تومان</span>
                    </div>
                  </div>
                  <div className="creditDetails">
                    <span className="maGraySpan">هزینه ارسال</span>
                    <div className="creditDetailsSpans">
                      <span className="maBlackSpan">
                        {this.state.postAmount === null
                          ? "ندارد"
                          : this.state.myOrderDetails.delivery_cost}
                      </span>
                      &nbsp;
                      {this.state.postAmount === null ? (
                        ""
                      ) : (
                        <span className="maBlackSpan">تومان</span>
                      )}
                    </div>
                  </div>
                  <div className="creditDetails">
                    <span className="maGraySpan">تخفیف</span>
                    <div className="creditDetailsSpans">
                      <span className="maBlackSpan">
                        {this.state.myOrderDetails.dis_amount}
                      </span>
                      &nbsp;
                      <span className="maBlackSpan">تومان</span>
                    </div>
                  </div>
                  <div className="creditDetails">
                    <span className="maGraySpan">تخفیف</span>
                    <div className="creditDetailsSpans">
                      <span className="maBlackSpan">
                        {this.state.myOrderDetails.final_price}
                      </span>
                      &nbsp;
                      <span className="maBlackSpan">تومان</span>
                    </div>
                  </div>
                  <div className="creditDetails">
                    <span className="maGraySpan">نوع پرداخت</span>
                    <div className="creditDetailsSpans">
                      <span className="maBlackSpan">
                        {this.state.myOrderDetails ? "در محل" : "آنلاین"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="orderDetailsButton">
                {this.state.myOrderDetails.status_text !==
                ("تحویل شده" || "ارسال شده") ? (
                  <Link
                    className="DetailsButton cancelOrder"
                    onClick={() =>
                      this.props.history.push({
                        pathname: `${this.props.match.params.id}/cancelOrder`,
                      })
                    }
                  >
                    لفو سفارش
                  </Link>
                ) : null}
                <button
                  className="DetailsButton "
                  type="submit"
                  onClick={() => this.pushTicket()}
                >
                  خدمات پس از فروش
                </button>
                <button className="DetailsButton" onClick={this.getFactorUrl}>
                  فاکتور
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(OrderDetails);
